import { CrmFieldFilter } from "types/Models/crmFields";

/**
 * Packs CRM field conditions into a base64url blob for the URL.
 *
 * Percent-encoded JSON roughly triples in length; base64url needs no escaping
 * at all, so the query string stays readable next to the other filters.
 */
export const encodeCrmFilters = (filters: CrmFieldFilter[]): string | null => {
  if (filters.length === 0) {
    return null;
  }

  const json = JSON.stringify(filters);
  const utf8Safe = encodeURIComponent(json).replace(
    /%([0-9A-F]{2})/g,
    (_, hex: string) => String.fromCharCode(parseInt(hex, 16))
  );

  return window
    .btoa(utf8Safe)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};
